import { jsx as _jsx } from "react/jsx-runtime";
import { LanguageSelectorList } from "../LanguageSelectorList";
import styles from "./LanguageSelectorPopupDesktop.module.scss";
export const LanguageSelectorPopupDesktop = ({ languages, isOpened, onSelectLanguage, }) => {
    if (!isOpened) {
        return null;
    }
    return (_jsx("div", { "data-testid": "languageSelectorPopupDesktop", className: styles.container, children: _jsx(LanguageSelectorList, { languages: languages, selectedLanguage: languages.find(({ current }) => current), onSelectLanguage: onSelectLanguage }) }));
};
//# sourceMappingURL=LanguageSelectorPopupDesktop.js.map